import HowBigIsTheBudget from "./HowBigIsTheBudget"

export default HowBigIsTheBudget
